import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from '@motorway/motorway-component-library';

import MoreMenuModalContent from './ModeMenuModalContent/ModeMenuModalContent';

const MoreMenuModal = ({ onDismissModal, onMutateDeliveryStatus }) => (
	<Modal centered dark dismissModal={onDismissModal} size="small">
		<MoreMenuModalContent dismissModal={onDismissModal} onMutateDeliveryStatus={onMutateDeliveryStatus} />
	</Modal>
);

MoreMenuModal.propTypes = {
	onDismissModal: PropTypes.func.isRequired,
	onMutateDeliveryStatus: PropTypes.func.isRequired,
};

export default MoreMenuModal;
